export const HEADER_HEIGHT = '90px'; // assuming a 80px default logo
